import React, { useRef } from "react";
import useOcReveal from "../useOcReveal";
import "./Markets.scss";

import photoVietnam from "../../../assets/images/home/06-markets/photo-vietnam.png";
import photoIndia from "../../../assets/images/home/06-markets/photo-india.png";
import flagVietnam from "../../../assets/images/home/06-markets/flag-vietnam.svg";
import flagIndia from "../../../assets/images/home/06-markets/flag-india.svg";

const MarketCard = ({ photo, name, desc, flag, stat, statLabel, delay }) => (
  <div className="market-card oc-reveal" style={delay ? { "--oc-delay": delay } : undefined}>
    <div className="market-card__photo">
      <img src={photo} alt={name} loading="lazy" />
    </div>
    <div className="market-card__body">
      <div className="market-card__text">
        <p className="market-card__name">{name}</p>
        <p className="market-card__desc">{desc}</p>
      </div>
      <div className="market-card__stat">
        <img className="market-card__flag" src={flag} alt={`${name} flag`} />
        <div>
          <div className="market-card__stat-num">{stat}</div>
          <div className="market-card__stat-label">{statLabel}</div>
        </div>
      </div>
    </div>
  </div>
);

export default function Markets() {
  const sectionRef = useRef(null);
  useOcReveal(sectionRef);

  return (
    <section className="markets" ref={sectionRef}>
      <div className="markets__inner">
        <div className="markets__heading oc-reveal">
          <h2>Growing across real education markets</h2>
          <p>
            Open Campus works with partners across Asia to bring AI, credentials, and learning
            infrastructure closer to students, schools, and institutions.
          </p>
        </div>

        <div className="markets__cards">
          <MarketCard
            photo={photoVietnam}
            name="Vietnam"
            delay="0.12s"
            desc="From education apps to academies to recruiting firms, Open Campus is building a strategic network and alliance of like-minded organizations looking to support lifelong learners in Vietnam and beyond."
            flag={flagVietnam}
            stat="10 million"
            statLabel="Addressable learners in Vietnam"
          />
          <MarketCard
            photo={photoIndia}
            name="India"
            delay="0.2s"
            desc="Working with the government of Madhya Pradesh and Barkatullah University, Open Campus is pioneering the usage of verifiable credentials in education and supporting graduates on their lifelong learning journey."
            flag={flagIndia}
            stat="50M+"
            statLabel="Student records across 3 states"
          />
        </div>
      </div>
    </section>
  );
}
